<template>
    <div class="CourseLive_header__title">
        <div class="title_wrap">
            <div class="wrap">
                <div class="title">
                    <span class="turn"><span class="point">제14회</span> A to Z 연수강좌</span>
                    <span class="eng">Atherosclerosis to Zero</span>
                </div>
                
                <v-btn v-if="isListPage" @click="downloadGreenBook" elevation="0" class="btn ml-4">
                    <v-icon class="mdi mdi-download" icon color="#ffffff"/> 
                    <span>초록집</span>
                </v-btn>
            </div>

            <!-- 평점 표기 임시 비활성화: 복구 시 아래 주석만 제거
            <div class="rating-section">
                <div class="rating-item">
                    <p class="rating-label">대한의사협회 평점<span>(예정)</span></p>
                    <div class="score">
                        <b>{{ associationScore !== null ? associationScore : 0 }}</b>점
                    </div>
                </div>

                <div
                    class="rating-item"
                    v-if="specialistScore !== null"
                    >
                    <p class="rating-label">분과전문의 평점<span>(예정)</span></p>
                    <div class="score">
                        <b>{{ specialistScore }}</b>점
                    </div>
                </div>
            </div>
            -->
            
        </div>
        
        <div class="button_group">

            <v-tooltip bottom v-if="isPlayPage">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="goBack" large elevation="0" icon>
                <v-icon class="mdi mdi-keyboard-backspace" icon color="#aaaaaa"/>
                </v-btn>
            </template>
            <span>이전으로</span>
            </v-tooltip>
    
            <v-tooltip bottom v-if="isexitPage">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="exitBtn" large elevation="0" icon>
                <v-icon class="mdi mdi-logout" icon color="#aaaaaa"/>
                </v-btn>
            </template>
            <span>나가기</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    props: {
        isListPage: {
            type: Boolean,
            default: false
        },
        isPlayPage: {
            type: Boolean,
            default: false
        },
        isexitPage: {
            type: Boolean,
            default: false
        },
        associationScore: {
            type: Number,
            default: null,
        },
        specialistScore: {
            type: Number,
            default: null,
        },
    },
    methods: {
        ...mapActions('user', ['logout']),
        exitBtn() {
            this.logout()
                .then(() => {
                    this.$router.push({ path: '/' });
                })
                .catch(error => {
                    console.error('Logout error:', error);
                });
        },
        goBack() {
            window.history.back();
        },
        downloadGreenBook() {
            const link = document.createElement('a');
            link.href = '/pdf/Abstract_manuscript.pdf';
            link.download = '14 ATOZ 초록집.pdf';
            link.click();
            // link.href = '/pdf/bb.pdf';
            // link.download = '한국지질동맥경화학회 제8회 AtoZ 연수강좌 초록집(e-book).pdf';
            // link.click();
        },
    },
    mounted() {

    if (this.$route.name === 'play') {
            this.isListPage = false;
            this.isPlayPage = true;
            this.isexitPage = true;
        }
    },
};
</script>

<style scoped>
.btn { color: var(--white-color) !important; background-color: var(--primary-color) !important; margin-left: 12px;}
.btn span { font-size: 18px; }
.CourseLive_header__title { display: flex; justify-content: space-between; }
.CourseLive_header__title .wrap { display: flex; }
.CourseLive_header__title .title_wrap { display: flex; align-items: center; }

.CourseLive_header__title .title_wrap .turn { font-size: 24px; font-family: 'GmarketSansBold';}
.CourseLive_header__title .title_wrap .eng { font-size: 18px; margin-left: 8px; font-family: 'GmarketSansBold';}
.CourseLive_header__title .title_wrap .point { color: var(--primary-color);font-family: 'GmarketSansBold' !important; }

.rating-section { display: flex; margin-left: 12px; gap: 8px; justify-content: center; }
.rating-section .rating-item { display: flex; justify-content: center; align-items: center; }
.rating-section .rating-item p { margin: 0 8px 0 0; font-weight: bold; }
.rating-section .rating-item b { margin-right: 2px;color: var(--primary-color); }
.rating-section .rating-item .score { background: #f2f2f2; padding: 4px 8px; border-radius: 6px; }

@media screen and (max-width:600px) {
    .btn { width:100px }
    .btn span { font-size: 14px; }
}

@media screen and (max-width:1340px) {
    .CourseLive_header__secssion  { padding:0 16px; border-bottom: 1px solid #D8D8D8; height: 40px; display: flex; align-items: center; }
    .CourseLive_header__secssion .logo-m { display: block; height: 18px; }
    .CourseLive_header__secssion .logo-m img { height: 18px; }
    .CourseLive_header__secssion .logo { display: none; }
    .CourseLive_header__title { text-align: left; }
    .CourseLive_header__title .wrap { display: flex; }
    .CourseLive_header__title .title_wrap { display: block;font-size: 16px; }
    .CourseLive_header__title .turn { font-size: 18px; }
    .CourseLive_header__title .eng { font-size: 14px;}
    .CourseLive_header__title { padding: 16px 26px 16px 32px; }
    .btn { width:80px }
    .btn span { font-size: 12px; }
    .rating-section { justify-content: start; margin: 8px 0 0 0 }
}
@media screen and (max-width:600px) {
    .CourseLive_header__title { padding: 12px 16px; }
    .CourseLive_header__title .title_wrap .wrap { display: flex; }
    .CourseLive_header__title .title_wrap .turn { font-size: 14px; height: 20px; }
    .CourseLive_header__title .title_wrap .title { display: grid; }
    .CourseLive_header__title .title_wrap .eng { font-size: 12px; margin: 0}
    .rating-section { margin: 0; }
    .rating-section .rating-item p { font-size: 12px; margin-right: 4px; }
    .rating-section .rating-item .score { font-size: 12px; width: fit-content; }
    .btn { width:80px }
    .btn span { font-size: 12px; }
}

@media screen and (max-width:450px) {
.rating-section .rating-item { display: grid;justify-content: left; gap: 4px; }
.rating-section .rating-item .score { padding: 4px; }
}
</style>
